module.exports = __webpack_public_path__ + "8b4d6e74cffa8b09d37d84376cd22e12.svg";